/* eslint-disable no-case-declarations */
import { TranslateService } from '@ngx-translate/core';
import {
  AppointmentPermission,
  ColAction,
  ColActionId,
  DataBreachPermission,
  DataProtectionGovernancePermission,
  DetailAction,
  DocumentPermission,
  NavItem,
  NavItemsId,
  NavItemsType,
  PtConsoleRoutes,
  PtEntity,
  PtPermissions,
  PtUiAppRoutes,
} from '@pt/pt-models';
import { NavUtils } from '../nav.utils';
import { Employment, PrivacyRole } from '@ms-organization-entities';
import { of } from 'rxjs';
import { User } from 'it/primatoo/openapi/api/org/schemas/user/User';
import { IncidentReport } from 'it/primatoo/openapi/api/org/schemas/databreachprocess/listindicentreportresponse/IncidentReport';
import { AvailableOperations } from 'it/primatoo/openapi/api/org/schemas/common/AvailableOperations';
import { PermissionManager } from '@pt/pt-core';
import { Notification } from 'it/primatoo/openapi/api/org/schemas/notification/Notification';
import { isDevMode } from '@angular/core';

export class AppActionsBuilder {
  //Header buttons
  private saveBtn = NavUtils.buttonSave(
    this.translateService.stream('BUTTON.SAVE')
  );
  // private resetBtn = NavUtils.buttonReset(this.translateService.stream('BUTTON.RESET'));

  private reloadBtn = NavUtils.buttonReload();
  private obsoleteBtn = NavUtils.buttonObsolete(
    this.translateService.stream('BUTTON.OBSOLETE_ARCHIVE')
  );
  private exportBtn = NavUtils.buttonExport(
    this.translateService.stream('BUTTON.EXPORT')
  );
  private guarantorCategoriesBtn = NavUtils.button(
    NavItemsId.GUARANTOR_CATEGORY,
    this.translateService.stream('BUTTON.GUARANTOR_CATEGORY'),
    'ribbon-outline',
    null,
    null,
    [],
    [],
    ['btn', 'btn-outline-primary', 'btn-sm']
  );
  private incidentTeamBtn = NavUtils.button(
    NavItemsId.INCIDENT_TEAM,
    this.translateService.stream('BUTTON.INCIDENT_TEAM'),
    'people-outline',
    null,
    null,
    [],
    [],
    ['btn', 'btn-outline-primary', 'btn-sm']
  );
  private exportBtnWithRaw = NavUtils.buttonExportWithRaw(
    this.translateService.stream('BUTTON.EXPORT'),
    this.translateService.stream('BUTTON.EXPORT_RAW'),
    this.translateService.stream('BUTTON.EXPORT_TABLE')
  );
  //todo check use and assign permission
  private loadBtn = NavUtils.buttonUpload(
    this.translateService.stream('BUTTON.LOAD'),
    null,
    [],
    []
  );
  private newBtnOpenDialog = NavUtils.buttonCreate(
    this.translateService.stream('BUTTON.NEW'),
    null,
    [],
    []
  );

  //TableActions
  private showDetailsTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.DETAILS'),
    id: ColActionId.showDetail,
  };
  private permissionTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.PERMISSIONS'),
    id: ColActionId.permission,
  };

  private editTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.EDIT'),
    id: ColActionId.edit,
  };
  private openDocumentTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.OPEN'),
    id: ColActionId.open,
  };

  private obsoleteDocumentTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.MAKE_OBSOLETE'),
    id: ColActionId.obsolete,
  };
  private openNewTabDocumentTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.OPEN_NEW_TAB'),
    id: ColActionId.openNewTab,
  };
  private editEntityTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.EDIT'),
    id: ColActionId.edit,
  };
  private reopenTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.REOPEN_PROCESS'),
    id: ColActionId.reopen,
  };
  private publicTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.PUBLIC'),
    id: ColActionId.publish,
  };
  private snapshotTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.SNAPSHOT'),
    id: ColActionId.snapshot,
  };
  private validateTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.VALIDATE'),
    id: ColActionId.validate,
  };
  private duplicateTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.DUPLICATE'),
    id: ColActionId.duplicate,
  };

  private duplicateTableBtnForTest: ColAction = {
    label: of('DUPLICAZIONE (solo per test)'),
    id: ColActionId.duplicateForTest,
  };
  private duplicateAsResponsibleTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.DUPLICATE_AS_RESPONSIBLE'),
    id: ColActionId.duplicateAsResponsible,
  };
  private downloadPdfTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.DOWNLOAD_PDF'),
    id: ColActionId.downloadPdf,
    disabled: false,
  };

  private archiveBtn: ColAction = {
    label: this.translateService.stream('BUTTON.ARCHIVE'),
    id: ColActionId.archive,
    disabled: false,
  };
  private closeBtn: ColAction = {
    label: this.translateService.stream('BUTTON.CLOSE'),
    id: ColActionId.close,
    disabled: false,
  };
  private deleteTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.DELETE'),
    id: ColActionId.delete,
  };

  private cancelDeleteTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.CANCEL_DELETE'),
    id: ColActionId.cancelDelete,
  };
  private visitCustomerDomainTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.VISIT_CUSTOMER_DOMAIN'),
    id: ColActionId.visitCustomerDomain,
  };
  private disableTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.DISABLE'),
    id: ColActionId.disable,
  };
  private enableTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.ENABLE'),
    id: ColActionId.enable,
  };
  private increasePriorityTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.INCREASE_PRIORITY'),
    id: ColActionId.increasePriority,
  };
  private decreasePriorityTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.DECREASE_PRIORITY'),
    id: ColActionId.decreasePriority,
  };
  private editPriorityTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.EDIT_PRIORITY'),
    id: ColActionId.editPriority,
  };
  private unlockUserAccessTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.UNLOCK_USER_ACCESS'),
    id: ColActionId.unlockUserAccess,
  };
  private manageTableBtn: ColAction = {
    label: this.translateService.stream('BUTTON.MANAGE'),
    id: ColActionId.manage,
  };

  constructor(
    private translateService: TranslateService,
    private permissionManager: PermissionManager
  ) {}

  public ofHeader(entity: PtEntity): NavItem[] {
    switch (entity) {
      case 'department':
        return [
          this.exportBtn,
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE +
              '/' +
              PtUiAppRoutes.DEPARTMENTS +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            [PtPermissions.DPG]
          ),
          this.reloadBtn,
        ];
      case 'dataBreachConfiguration':
        return [this.saveBtn, this.reloadBtn];
      case 'dataBreach': {
        return [this.reloadBtn];
      }
      case 'incidentReport':
        return [
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            null,
            [PtPermissions.CAN_CREATE_DATABREACH],
            []
          ),
          this.reloadBtn,
        ];
      case 'genericReport':
        return [this.reloadBtn];
      case 'notifications':
        return [this.reloadBtn];

      //--------------------------------------- OfHeader for DPG ---------------------------------------//
      case 'legalEntity': {
        const newLegalEntityBtn: NavItem = {
          ...this.newBtnOpenDialog,
          id: NavItemsId.NEW_LEGAL_ENTITY,
          permissVisible: [PtPermissions.DPG],
          children: [
            {
              id: NavItemsId.INTERNAL,
              type: NavItemsType.MENU,
              label: this.translateService.stream(
                'BUTTON.INTERNAL_LEGAL_ENTITY'
              ),
              permissEnabled: [],
              permissVisible: [PtPermissions.DPG],
              disabled: of(false),
            },
            {
              id: NavItemsId.EXTERNAL,
              type: NavItemsType.MENU,
              label: this.translateService.stream(
                'BUTTON.EXTERNAL_LEGAL_ENTITY'
              ),
              permissEnabled: [],
              permissVisible: [PtPermissions.DPG],
              disabled: of(false),
            },
          ],
        };

        return [
          this.exportBtnWithRaw,
          { ...this.loadBtn, permissVisible: [PtPermissions.DPG] },
          newLegalEntityBtn,
          this.reloadBtn,
        ];
      }
      case 'organizationalFunctions':
        return [
          this.exportBtnWithRaw,
          { ...this.loadBtn, permissVisible: [PtPermissions.DPG] },
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE +
              '/' +
              PtUiAppRoutes.ORGANIZATIONAL_FUNCTIONS +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            [PtPermissions.DPG]
          ),
          this.reloadBtn,
        ];
      case 'userResources':
        return [
          this.exportBtnWithRaw,
          { ...this.loadBtn, permissVisible: [PtPermissions.DPG] },
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE +
              '/' +
              PtUiAppRoutes.USERS_RESOURCES +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            [PtPermissions.DPG]
          ),
          this.reloadBtn,
        ];
      case 'privacyRole':
        return [
          this.exportBtn,
          { ...this.loadBtn, permissVisible: [PtPermissions.DPG] },
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE +
              '/' +
              PtUiAppRoutes.PRIVACY_ROLES +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            [PtPermissions.DPG]
          ),
          this.reloadBtn,
        ];
      case 'employmentRelationship':
        return [
          this.exportBtn,
          { ...this.loadBtn, permissVisible: [PtPermissions.DPG] },
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE +
              '/' +
              PtUiAppRoutes.EMPLOYMENT_RELATIONSHIP +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            [PtPermissions.DPG]
          ),
          this.reloadBtn,
        ];
      case 'applicationTypes':
        return [
          this.exportBtn,
          { ...this.loadBtn, permissVisible: [PtPermissions.DPG] },
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE +
              '/' +
              PtUiAppRoutes.APPLICATION_TYPES +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            [PtPermissions.DPG]
          ),
          this.reloadBtn,
        ];
      case 'regulations':
        return [
          this.exportBtn,
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE +
              '/' +
              PtUiAppRoutes.REGULATIONS +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            [PtPermissions.DPG]
          ),
          this.reloadBtn,
        ];
      case 'notices':
        return [
          this.exportBtn,
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE +
              '/' +
              PtUiAppRoutes.NOTICES +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            [PtPermissions.DPG]
          ),
          this.reloadBtn,
        ];
      case 'purposeCategory':
        return [
          this.exportBtn,
          { ...this.loadBtn, permissVisible: [PtPermissions.DPG] },
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE +
              '/' +
              PtUiAppRoutes.PURPOSE_CATEGORIES +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            [PtPermissions.DPG]
          ),
          this.reloadBtn,
        ];
      case 'applications':
        return [
          this.exportBtnWithRaw,
          { ...this.loadBtn, permissVisible: [PtPermissions.DPG] },
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE +
              '/' +
              PtUiAppRoutes.APPLICATIONS +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            [PtPermissions.DPG]
          ),
          this.reloadBtn,
        ];
      case 'recipients':
        return [
          this.exportBtnWithRaw,
          { ...this.loadBtn, permissVisible: [PtPermissions.DPG] },
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE +
              '/' +
              PtUiAppRoutes.RECIPIENTS +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            [PtPermissions.DPG]
          ),
          this.reloadBtn,
        ];
      case 'suppliers':
        return [
          this.exportBtn,
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE +
              '/' +
              PtUiAppRoutes.SUPPLIERS +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            [PtPermissions.DPG]
          ),
          this.reloadBtn,
        ];
      case 'treatmentCategory':
        return [
          this.exportBtn,
          // this.loadBtn, todo temporal hide
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE +
              '/' +
              PtUiAppRoutes.TREATMENT_CATEGORY +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            [PtPermissions.DPG]
          ),
          this.reloadBtn,
        ];

      //--------------------------------------- OfHeader for BPM ---------------------------------------//
      case 'treatmentsHolder':
        return [
          this.obsoleteBtn,
          this.exportBtn,
          {
            ...this.newBtnOpenDialog,
            permissVisible: [PtPermissions.CAN_CREATE_TREAT],
          },
          this.reloadBtn,
        ];
      case 'dpia':
        return [this.exportBtn, this.reloadBtn];
      case 'lia':
        return [this.exportBtn, this.reloadBtn];
      case 'treatmentsResponsible':
        return [
          this.obsoleteBtn,
          this.exportBtn,
          {
            ...this.newBtnOpenDialog,
            permissVisible: [PtPermissions.CAN_CREATE_TREAT],
          },
          this.reloadBtn,
        ];
      case 'treatmentsSubResponsible':
        return [
          this.obsoleteBtn,
          this.exportBtn,
          {
            ...this.newBtnOpenDialog,
            permissVisible: [PtPermissions.CAN_CREATE_TREAT],
          },
          this.reloadBtn,
        ];
      case 'projectCards':
        return [
          this.obsoleteBtn,
          this.exportBtn,
          {
            ...this.newBtnOpenDialog,
            permissVisible: [PtPermissions.CAN_CREATE_TREAT],
          },
          this.reloadBtn,
        ];
      case 'appointments':
        return [
          this.exportBtn,
          { ...this.newBtnOpenDialog, permissVisible: [PtPermissions.DPG] },
          this.reloadBtn,
        ];
      case 'appAssessment':
        return [this.exportBtn, this.reloadBtn];
      case 'globalMeasureCheck':
        return [
          this.exportBtn,
          { ...this.newBtnOpenDialog }, // , permissVisible: [PtPermissions.CAN_CREATE_RISK_AS]},
          this.reloadBtn,
        ];
      case 'aiAssessment':
        return [
          this.exportBtn,
          {
            ...this.newBtnOpenDialog,
            permissVisible: [PtPermissions.CAN_CREATE_AI_AS],
          },
          this.reloadBtn,
        ];
      case 'covidAssessment':
        return [
          this.exportBtn,
          {
            ...this.newBtnOpenDialog,
            permissVisible: [PtPermissions.CAN_CREATE_COVID_AS],
          },
          this.reloadBtn,
        ];

      //--------------------------------------- OfHeader for ADMINISTRATION ---------------------------------------//
      case 'organizationalMeasures':
        return [
          this.exportBtn,
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION +
              '/' +
              PtUiAppRoutes.SECURITY_MEASURES +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            []
          ),
          this.reloadBtn,
        ];
      case 'organizationalMeasureCategories':
        return [
          this.exportBtn,
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION +
              '/' +
              PtUiAppRoutes.SECURITY_MEASURE_CATEGORIES +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            []
          ),
          this.reloadBtn,
        ];
      case 'technicalMeasures':
        return [
          this.exportBtn,
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION +
              '/' +
              PtUiAppRoutes.TECHNICAL_MEASURES +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            []
          ),
          this.reloadBtn,
        ];
      case 'technicalMeasureCategories':
        return [
          this.exportBtn,
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION +
              '/' +
              PtUiAppRoutes.TECHNICAL_MEASURE_CATEGORIES +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            []
          ),
          this.reloadBtn,
        ];
      case 'preliminaryRiskAssessment':
        return [
          this.exportBtn,
          // this.loadBtn, todo temporal hide
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION +
              '/' +
              PtUiAppRoutes.PRELIMINARY_RISK_ASSESSMENTS +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            []
          ),
          this.reloadBtn,
        ];
      case 'interestedPersonCategories':
        return [
          this.exportBtn,
          // this.loadBtn, todo temporal hide
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION +
              '/' +
              PtUiAppRoutes.INTERESTED_PERSON_CATEGORIES +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            []
          ),
          this.reloadBtn,
        ];
      case 'natureOfData':
        return [
          this.exportBtn,
          // this.loadBtn, todo temporal hide
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION +
              '/' +
              PtUiAppRoutes.NATURE_OF_DATA +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            []
          ),
          this.reloadBtn,
        ];
      case 'damage':
        return [
          this.exportBtn,
          // this.loadBtn, todo temporal hide
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION +
              '/' +
              PtUiAppRoutes.DAMAGES +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            []
          ),
          this.reloadBtn,
        ];
      case 'legalBasis':
        return [
          this.exportBtn,
          // this.loadBtn, todo temporal hide
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION +
              '/' +
              PtUiAppRoutes.LEGAL_BASIS +
              '/' +
              PtUiAppRoutes.CREATE,
            [],
            []
          ),
          this.reloadBtn,
        ];
      case 'email':
        return [this.reloadBtn];
      case 'permissionRules':
        return [
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            null,
            [],
            []
          ),
          this.reloadBtn,
        ];
      case 'users':
        return [
          this.exportBtnWithRaw,
          this.loadBtn,
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            null,
            [],
            []
          ),
          this.reloadBtn,
        ];
      case 'userGroups':
        return [
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            null,
            [],
            []
          ),
          this.reloadBtn,
        ];

      // todo ask for console permissions
      //--------------------------------------- OfHeader for Console UI ---------------------------------------//
      case 'consoleOrganizations':
        return [
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtConsoleRoutes.ORGANIZATIONS + '/' + PtUiAppRoutes.CREATE,
            [],
            []
          ),
          this.reloadBtn,
        ];
      case 'consoleUsers':
        return [
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            PtConsoleRoutes.USERS + '/' + PtUiAppRoutes.CREATE,
            [],
            []
          ),
          this.reloadBtn,
        ];
      case 'securityCenter':
        return [this.reloadBtn];
      case 'cyberSecurity':
        return [this.reloadBtn];
      case 'assessmentQuestion':
        return [
          NavUtils.buttonCreate(
            this.translateService.stream('BUTTON.NEW'),
            null,
            [],
            []
          ),
          this.reloadBtn,
        ];
    }
    console.error('Not found entity ', entity);
    return [];
  }

  //----------------------------------------------- ofHeader End ---------------------------------------------------//

  //----------------------------------------------- DETAIL ---------------------------------------------------//

  public ofDetailsPageDataBreach(
    entity: PtEntity,
    entityDetailsPayload: any
  ): DetailAction[] {
    const dpgPermissions: DataProtectionGovernancePermission =
      this.permissionManager.dpgPermission(entityDetailsPayload);

    switch (entity) {
      case 'incidentReport':
        const db: IncidentReport = entityDetailsPayload;
        return [
          {
            ...this.showDetailsTableBtn,
            visible: false, // permissionDB.detailBtnVisible,
            disabled: false, // !permissionDB.detailBtnEnabled,
          },
          {
            ...this.cancelDeleteTableBtn,
            separateFromAbove: true,
            disabled: !db.deletionAt,
            visible: true,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: false,
            visible: dpgPermissions.dpgPermission,
            disabled: !!db.deletionAt,
          },
        ];
      case 'genericReport':
        return [
          {
            ...this.manageTableBtn,
            visible: dpgPermissions.dpgPermission,
            disabled: false,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: dpgPermissions.dpgPermission,
            disabled: false,
          },
        ];
      case 'notifications':
        return [
          {
            ...this.openDocumentTableBtn,
            visible: dpgPermissions.dpgPermission,
            disabled: false,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: dpgPermissions.dpgPermission,
            disabled: false,
          },
        ];
    }
    return [];
  }

  public ofDetailsPageDataBreach2(
    entity: PtEntity,
    availableOperations: AvailableOperations
  ): DetailAction[] {
    const permissionDB: DataBreachPermission =
      this.permissionManager.dataBreachPermission2(availableOperations);
    return [
      {
        ...this.openDocumentTableBtn,
        visible: permissionDB.openBtnVisible,
        disabled: !permissionDB.openBtnEnabled,
      },
      {
        ...this.archiveBtn,
        visible: permissionDB.archiveBtnVisible,
        disabled: !permissionDB.archiveBtnEnabled,
      },
      {
        ...this.closeBtn,
        visible: permissionDB.closeBtnVisible,
        disabled: !permissionDB.closeBtnEnabled,
      },
      {
        ...this.permissionTableBtn,
        visible: permissionDB.permissionBtnVisible,
        disabled: !permissionDB.permissionBtnEnabled,
      },
      {
        ...this.cancelDeleteTableBtn,
        separateFromAbove: true,
        visible: permissionDB.cancelDeleteBtnVisible,
        disabled: !permissionDB.cancelDeleteBtnEnabled,
      },
      {
        ...this.deleteTableBtn,
        visible: permissionDB.deleteBtnVisible,
        disabled: !permissionDB.deleteBtnEnabled,
      },
    ];
  }

  public ofDetailsPageDPG(
    entity: PtEntity,
    entityDetailsPayload: any
  ): DetailAction[] {
    switch (entity) {
      case 'department': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'legalEntity': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'organizationalFunctions': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'userResources': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'privacyRole': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        const entity: PrivacyRole = entityDetailsPayload;
        return [
          {
            ...this.editTableBtn,
            visible: permissionDPG.dpgPermission,
            disabled: !permissionDPG.system
              ? permissionDPG.requiredBuiltIn
              : false,
          },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
            disabled: entity.builtIn,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'employmentRelationship': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        const entity: Employment = entityDetailsPayload;
        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
            disabled: entity.builtIn,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'applications': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'applicationTypes': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'regulations': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'notices': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'purposeCategory': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'recipients': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'suppliers': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'treatmentCategory': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
    }
    return [];
  }

  public ofDetailsPageBPM(
    entity: PtEntity,
    operations: AvailableOperations
  ): DetailAction[] {
    switch (entity) {
      case 'dpia':
        const dpiaPermission: DocumentPermission =
          this.permissionManager.treatmentPermission(operations);
        return [
          {
            ...this.openDocumentTableBtn,
            disabled: !dpiaPermission.openBtnEnabled,
            visible: dpiaPermission.openBtnVisible,
          },
          {
            ...this.openNewTabDocumentTableBtn,
            disabled: !dpiaPermission.openBtnEnabled,
            visible: dpiaPermission.openBtnVisible,
          },
          {
            ...this.downloadPdfTableBtn,
            separateFromAbove: true,
            disabled: !dpiaPermission.downloadBtnEnabled,
            visible: dpiaPermission.downloadBtnVisible,
          },
          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            disabled: !dpiaPermission.detailBtnEnabled,
            visible: dpiaPermission.detailBtnVisible,
          },
        ];
      case 'lia':
        const liaPermission: DocumentPermission =
          this.permissionManager.treatmentPermission(operations);
        return [
          {
            ...this.openDocumentTableBtn,
            disabled: !liaPermission.openBtnEnabled,
            visible: liaPermission.openBtnVisible,
          },
          {
            ...this.openNewTabDocumentTableBtn,
            disabled: !liaPermission.openBtnEnabled,
            visible: liaPermission.openBtnVisible,
          },
          {
            ...this.downloadPdfTableBtn,
            separateFromAbove: true,
            disabled: !liaPermission.downloadBtnEnabled,
            visible: liaPermission.downloadBtnVisible,
          },
          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            disabled: !liaPermission.detailBtnEnabled,
            visible: liaPermission.detailBtnVisible,
          },
        ];
      case 'treatmentsHolder': {
        const treatmentPermission: DocumentPermission =
          this.permissionManager.treatmentPermission(operations);
        return [
          {
            ...this.openDocumentTableBtn,
            disabled: !treatmentPermission.openBtnEnabled,
            visible: treatmentPermission.openBtnVisible,
          },
          {
            ...this.openNewTabDocumentTableBtn,
            disabled: !treatmentPermission.openBtnEnabled,
            visible: treatmentPermission.openBtnVisible,
          },
          {
            ...this.publicTableBtn,
            disabled: !treatmentPermission.publishBtnEnabled,
            visible: treatmentPermission.publishBtnVisible,
          },
          {
            ...this.reopenTableBtn,
            disabled: !treatmentPermission.reopenBtnEnabled,
            visible: treatmentPermission.reopenBtnVisible,
          },
          {
            ...this.obsoleteDocumentTableBtn,
            disabled: !treatmentPermission.obsoleteBtnEnabled,
            visible: treatmentPermission.obsoleteBtnVisible,
          },
          {
            ...this.snapshotTableBtn,
            disabled: !treatmentPermission.snapshotBtnEnabled,
            visible: treatmentPermission.snapshotBtnVisible,
          },
          {
            ...this.validateTableBtn,
            disabled: !treatmentPermission.validateBtnEnabled,
            visible: treatmentPermission.validateBtnVisible,
          },
          {
            ...this.duplicateTableBtn,
            disabled: !treatmentPermission.duplicateBtnEnabled,
            visible: treatmentPermission.duplicateBtnVisible,
          },
          {
            ...this.duplicateAsResponsibleTableBtn,
            disabled: !treatmentPermission.duplicateBtnEnabled,
            visible: treatmentPermission.duplicateBtnVisible,
          },
          {
            ...this.duplicateTableBtnForTest,
            disabled: !treatmentPermission.duplicateBtnEnabled,
            visible: isDevMode(),
          },
          {
            ...this.permissionTableBtn,
            disabled: !treatmentPermission.permissionBtnEnabled,
            visible: treatmentPermission.permissionBtnVisible,
          },
          {
            ...this.downloadPdfTableBtn,
            separateFromAbove: true,
            disabled: !treatmentPermission.downloadBtnEnabled,
            visible: treatmentPermission.downloadBtnVisible,
          },
          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            disabled: !treatmentPermission.detailBtnEnabled,
            visible: treatmentPermission.detailBtnVisible,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            disabled: !treatmentPermission.deleteBtnEnabled,
            visible: treatmentPermission.deleteBtnVisible,
          },
        ];
      }
      case 'treatmentsResponsible':
      case 'treatmentsSubResponsible':
      case 'projectCards': {
        const treatmentPermission: DocumentPermission =
          this.permissionManager.treatmentPermission(operations);
        return [
          {
            ...this.openDocumentTableBtn,
            disabled: !treatmentPermission.openBtnEnabled,
            visible: treatmentPermission.openBtnVisible,
          },
          {
            ...this.openNewTabDocumentTableBtn,
            disabled: !treatmentPermission.openBtnEnabled,
            visible: treatmentPermission.openBtnVisible,
          },
          {
            ...this.publicTableBtn,
            disabled: !treatmentPermission.publishBtnEnabled,
            visible: treatmentPermission.publishBtnVisible,
          },
          {
            ...this.reopenTableBtn,
            disabled: !treatmentPermission.reopenBtnEnabled,
            visible: treatmentPermission.reopenBtnVisible,
          },
          {
            ...this.obsoleteDocumentTableBtn,
            disabled: !treatmentPermission.obsoleteBtnEnabled,
            visible: treatmentPermission.obsoleteBtnVisible,
          },
          {
            ...this.snapshotTableBtn,
            disabled: !treatmentPermission.snapshotBtnEnabled,
            visible: treatmentPermission.snapshotBtnVisible,
          },
          {
            ...this.validateTableBtn,
            disabled: !treatmentPermission.validateBtnEnabled,
            visible: treatmentPermission.validateBtnVisible,
          },
          {
            ...this.duplicateTableBtn,
            disabled: !treatmentPermission.duplicateBtnEnabled,
            visible: treatmentPermission.duplicateBtnVisible,
          },
          {
            ...this.permissionTableBtn,
            disabled: !treatmentPermission.permissionBtnEnabled,
            visible: treatmentPermission.permissionBtnVisible,
          },
          {
            ...this.downloadPdfTableBtn,
            separateFromAbove: true,
            disabled: !treatmentPermission.downloadBtnEnabled,
            visible: treatmentPermission.downloadBtnVisible,
          },
          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            disabled: !treatmentPermission.detailBtnEnabled,
            visible: treatmentPermission.detailBtnVisible,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            disabled: !treatmentPermission.deleteBtnEnabled,
            visible: treatmentPermission.deleteBtnVisible,
          },
        ];
      }
      case 'appointments':
        const appointmentPermission: AppointmentPermission =
          this.permissionManager.appointmentPermission();
        return [
          {
            ...this.editEntityTableBtn,
            visible: appointmentPermission.editBtnVisible,
            disabled: !appointmentPermission.editBtnEnabled,
          },
          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            visible: appointmentPermission.editBtnVisible,
            disabled: !appointmentPermission.editBtnEnabled,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: appointmentPermission.deleteBtnVisible,
            disabled: !appointmentPermission.deleteBtnEnabled,
          },
        ];
      case 'appAssessment':
        const appAssessmentPermission: DocumentPermission =
          this.permissionManager.appAssessmentPermissionV2(operations);
        return [
          {
            ...this.openDocumentTableBtn,
            disabled: !appAssessmentPermission.openBtnEnabled,
            visible: appAssessmentPermission.openBtnVisible,
          },
          {
            ...this.openNewTabDocumentTableBtn,
            disabled: !appAssessmentPermission.openBtnEnabled,
            visible: appAssessmentPermission.openBtnVisible,
          },
          {
            ...this.publicTableBtn,
            disabled: !appAssessmentPermission.publishBtnEnabled,
            visible: appAssessmentPermission.publishBtnVisible,
          },
          {
            ...this.reopenTableBtn,
            disabled: !appAssessmentPermission.reopenBtnEnabled,
            visible: appAssessmentPermission.reopenBtnVisible,
          },
          {
            ...this.snapshotTableBtn,
            disabled: !appAssessmentPermission.snapshotBtnEnabled,
            visible: appAssessmentPermission.snapshotBtnVisible,
          },
          {
            ...this.validateTableBtn,
            disabled: !appAssessmentPermission.validateBtnEnabled,
            visible: appAssessmentPermission.validateBtnVisible,
          },
          {
            ...this.duplicateTableBtn,
            disabled: !appAssessmentPermission.duplicateBtnEnabled,
            visible: appAssessmentPermission.duplicateBtnVisible,
          },
          {
            ...this.permissionTableBtn,
            disabled: !appAssessmentPermission.permissionBtnEnabled,
            visible: appAssessmentPermission.permissionBtnVisible,
          },
          {
            ...this.downloadPdfTableBtn,
            separateFromAbove: true,
            disabled: !appAssessmentPermission.downloadBtnEnabled,
            visible: appAssessmentPermission.downloadBtnVisible,
          },

          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            disabled: !appAssessmentPermission.detailBtnEnabled,
            visible: appAssessmentPermission.detailBtnVisible,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            disabled: !appAssessmentPermission.deleteBtnEnabled,
            visible: appAssessmentPermission.deleteBtnVisible,
          },
        ];
      case 'globalMeasureCheck':
        const riskAssessmentPermission: DocumentPermission =
          this.permissionManager.globalMeasureCheckPermission(operations);
        return [
          {
            ...this.openDocumentTableBtn,
            disabled: !riskAssessmentPermission.openBtnEnabled,
            visible: riskAssessmentPermission.openBtnVisible,
          },
          {
            ...this.openNewTabDocumentTableBtn,
            disabled: !riskAssessmentPermission.openBtnEnabled,
            visible: riskAssessmentPermission.openBtnVisible,
          },
          {
            ...this.publicTableBtn,
            disabled: !riskAssessmentPermission.publishBtnEnabled,
            visible: riskAssessmentPermission.publishBtnVisible,
          },
          {
            ...this.reopenTableBtn,
            disabled: !riskAssessmentPermission.reopenBtnEnabled,
            visible: riskAssessmentPermission.reopenBtnVisible,
          },
          {
            ...this.snapshotTableBtn,
            disabled: !riskAssessmentPermission.snapshotBtnEnabled,
            visible: riskAssessmentPermission.snapshotBtnVisible,
          },
          {
            ...this.validateTableBtn,
            disabled: !riskAssessmentPermission.validateBtnEnabled,
            visible: riskAssessmentPermission.validateBtnVisible,
          },
          {
            ...this.duplicateTableBtn,
            disabled: !riskAssessmentPermission.duplicateBtnEnabled,
            visible: riskAssessmentPermission.duplicateBtnVisible,
          },
          {
            ...this.permissionTableBtn,
            disabled: !riskAssessmentPermission.permissionBtnEnabled,
            visible: riskAssessmentPermission.permissionBtnVisible,
          },
          {
            ...this.downloadPdfTableBtn,
            separateFromAbove: true,
            disabled: !riskAssessmentPermission.downloadBtnEnabled,
            visible: riskAssessmentPermission.downloadBtnVisible,
          },
          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            disabled: !riskAssessmentPermission.detailBtnEnabled,
            visible: riskAssessmentPermission.detailBtnVisible,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            disabled: !riskAssessmentPermission.deleteBtnEnabled,
            visible: riskAssessmentPermission.deleteBtnVisible,
          },
        ];
      case 'aiAssessment':
        const aiPermission: DocumentPermission =
          this.permissionManager.aiAssessmentPermission(operations);
        return [
          {
            ...this.openDocumentTableBtn,
            disabled: !aiPermission.openBtnEnabled,
            visible: aiPermission.openBtnVisible,
          },
          {
            ...this.openNewTabDocumentTableBtn,
            disabled: !aiPermission.openBtnEnabled,
            visible: aiPermission.openBtnVisible,
          },
          {
            ...this.publicTableBtn,
            disabled: !aiPermission.publishBtnEnabled,
            visible: aiPermission.publishBtnVisible,
          },
          {
            ...this.reopenTableBtn,
            disabled: !aiPermission.reopenBtnEnabled,
            visible: aiPermission.reopenBtnVisible,
          },
          {
            ...this.snapshotTableBtn,
            disabled: !aiPermission.snapshotBtnEnabled,
            visible: aiPermission.snapshotBtnVisible,
          },
          {
            ...this.validateTableBtn,
            disabled: !aiPermission.validateBtnEnabled,
            visible: aiPermission.validateBtnVisible,
          },
          {
            ...this.duplicateTableBtn,
            disabled: !aiPermission.duplicateBtnEnabled,
            visible: aiPermission.duplicateBtnVisible,
          },
          {
            ...this.permissionTableBtn,
            disabled: !aiPermission.permissionBtnEnabled,
            visible: aiPermission.permissionBtnVisible,
          },
          {
            ...this.downloadPdfTableBtn,
            separateFromAbove: true,
            disabled: !aiPermission.downloadBtnEnabled,
            visible: aiPermission.downloadBtnVisible,
          },
          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            disabled: !aiPermission.detailBtnEnabled,
            visible: aiPermission.detailBtnVisible,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            disabled: !aiPermission.deleteBtnEnabled,
            visible: aiPermission.deleteBtnVisible,
          },
        ];
      case 'covidAssessment':
        const covidAssessmentPermission: DocumentPermission =
          this.permissionManager.covidAssessmentPermission(operations);
        return [
          {
            ...this.openDocumentTableBtn,
            disabled: !covidAssessmentPermission.openBtnEnabled,
            visible: covidAssessmentPermission.openBtnVisible,
          },
          {
            ...this.openNewTabDocumentTableBtn,
            disabled: !covidAssessmentPermission.openBtnEnabled,
            visible: covidAssessmentPermission.openBtnVisible,
          },
          {
            ...this.publicTableBtn,
            disabled: !covidAssessmentPermission.publishBtnEnabled,
            visible: covidAssessmentPermission.publishBtnVisible,
          },
          {
            ...this.reopenTableBtn,
            disabled: !covidAssessmentPermission.reopenBtnEnabled,
            visible: covidAssessmentPermission.reopenBtnVisible,
          },
          {
            ...this.snapshotTableBtn,
            disabled: !covidAssessmentPermission.snapshotBtnEnabled,
            visible: covidAssessmentPermission.snapshotBtnVisible,
          },
          {
            ...this.validateTableBtn,
            disabled: !covidAssessmentPermission.validateBtnEnabled,
            visible: covidAssessmentPermission.validateBtnVisible,
          },
          {
            ...this.duplicateTableBtn,
            disabled: !covidAssessmentPermission.duplicateBtnEnabled,
            visible: covidAssessmentPermission.duplicateBtnVisible,
          },
          {
            ...this.permissionTableBtn,
            disabled: !covidAssessmentPermission.permissionBtnEnabled,
            visible: covidAssessmentPermission.permissionBtnVisible,
          },
          {
            ...this.downloadPdfTableBtn,
            separateFromAbove: true,
            disabled: !covidAssessmentPermission.downloadBtnEnabled,
            visible: covidAssessmentPermission.downloadBtnVisible,
          },
          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            disabled: !covidAssessmentPermission.detailBtnEnabled,
            visible: covidAssessmentPermission.detailBtnVisible,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            disabled: !covidAssessmentPermission.deleteBtnEnabled,
            visible: covidAssessmentPermission.deleteBtnVisible,
          },
        ];
    }
    return [];
  }

  public ofDetailsPage(entity: PtEntity, entityPayload: any): DetailAction[] {
    let response = this.ofDetailsPageDataBreach(entity, entityPayload);
    if (response.length > 0) {
      return response;
    }

    response = this.ofDetailsPageDPG(entity, entityPayload);
    if (response.length > 0) {
      return response;
    }

    response = this.ofDetailsPageBPM(entity, entityPayload);
    if (response.length > 0) {
      return response;
    }

    response = this.ofDetailsPageAdministration(entity, entityPayload);
    if (response.length > 0) {
      return response;
    }

    response = this.ofDetailsPageConsoleUI(entity, entityPayload);
    if (response.length > 0) {
      return response;
    }

    return [];
  }

  public ofTable(entity: PtEntity, entityDetailsPayload: any): ColAction[] {
    let response = this.ofTableDataBreach(entity, entityDetailsPayload);
    if (response.length > 0) {
      return response;
    }

    response = this.ofTableDPG(entity, entityDetailsPayload);
    if (response.length > 0) {
      return response;
    }

    response = this.ofTableBPM(entity, entityDetailsPayload);
    if (response.length > 0) {
      return response;
    }

    response = this.ofTableAdministration(entity, entityDetailsPayload);
    if (response.length > 0) {
      return response;
    }

    response = this.ofTableConsoleUI(entity, entityDetailsPayload);
    if (response.length > 0) {
      return response;
    }

    return [];
  }

  private ofDetailsPageAdministration(
    entity: PtEntity,
    entityDetailsPayload: any
  ): DetailAction[] {
    switch (entity) {
      case 'organizationalMeasures':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'organizationalMeasureCategories':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'technicalMeasures':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'technicalMeasureCategories':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'preliminaryRiskAssessment':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'interestedPersonCategories':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'natureOfData':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'damage':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'legalBasis':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'userGroups':
        return [
          {
            ...this.editTableBtn,
            visible: true,
          },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'permissionRules':
        return [
          { ...this.editTableBtn, visible: true },
          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },
        ];
      case 'users':
        if (entityDetailsPayload?.loggedUser) {
          const loggedUser = entityDetailsPayload?.loggedUser;
          return [
            {
              ...this.editTableBtn,
              visible: true,
              disabled: !loggedUser?.system
                ? entityDetailsPayload?.builtIn
                : false,
            },
            { ...this.showDetailsTableBtn, separateFromAbove: true },
            {
              ...this.unlockUserAccessTableBtn,
              separateFromAbove: true,
              visible: true,
            },
            {
              ...this.deleteTableBtn,
              separateFromAbove: true,
              visible: true,
              disabled: !loggedUser?.system
                ? entityDetailsPayload?.builtIn
                : false,
            },
          ];
        } else {
          return [
            {
              ...this.editTableBtn,
              visible: true,
              disabled: entityDetailsPayload?.builtIn,
            },
            { ...this.showDetailsTableBtn, separateFromAbove: true },
            {
              ...this.unlockUserAccessTableBtn,
              separateFromAbove: true,
              visible: true,
            },
            {
              ...this.deleteTableBtn,
              separateFromAbove: true,
              visible: true,
              disabled: entityDetailsPayload?.builtIn,
            },
          ];
        }
    }
    return [];
  }

  private ofDetailsPageConsoleUI(
    entity: PtEntity,
    entityDetailsPayload: any
  ): DetailAction[] {
    switch (entity) {
      case 'consoleOrganizations':
        return [
          { ...this.editTableBtn, visible: true },

          {
            ...this.visitCustomerDomainTableBtn,
            separateFromAbove: true,
            visible: true,
          },

          {
            ...this.enableTableBtn,
            separateFromAbove: true,
            visible: true,
            disabled: entityDetailsPayload.enabled,
          },
          {
            ...this.disableTableBtn,
            separateFromAbove: true,
            visible: true,
            disabled: !entityDetailsPayload.enabled,
          },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },
        ];
      case 'consoleUsers': {
        const entity: User = entityDetailsPayload;
        return [
          {
            ...this.editEntityTableBtn,
            visible: true,
            disabled: entity.builtIn,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: true,
            disabled: entity.builtIn,
          },
        ];
      }
    }
    return [];
  }

  //----------------------------------------------- TABLE ---------------------------------------------------//
  private ofTableDataBreach(
    entity: PtEntity,
    entityDetailsPayload: any
  ): ColAction[] {
    switch (entity) {
      case 'genericReport': {
        // const db: GenericReport = entityDetailsPayload;
        //todo check @georgy
        // const permission: IncidentReportPermission = this.permissionManager.incidentReportPermission();
        return [
          {
            ...this.manageTableBtn,
            disabled: false, //!permission.permissionBtnEnabled,
            visible: true, //permission.permissionBtnVisible
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: true, //permission.deleteBtnVisible,
            // disabled: !!db.deletionAt
          },
        ];
      }
      case 'incidentReport': {
        const db: IncidentReport = entityDetailsPayload;
        const activeModuleDataBreach: boolean =
          this.permissionManager.currentPermission.includes(
            PtPermissions.ACTIVE_MODULE_DATABREACH
          );
        const canManageDataBreach: boolean =
          this.permissionManager.currentPermission.includes(
            PtPermissions.MANAGE_DATABREACH
          );
        const activeDataBreach = activeModuleDataBreach && canManageDataBreach;
        // const permissionDB: IncidentReportPermission = this.permissionManager.incidentReportPermission();
        return [
          {
            ...this.showDetailsTableBtn,
            disabled: false, // !permissionDB.detailBtnEnabled,
            visible: false, //permissionDB.detailBtnVisible
          },
          {
            ...this.cancelDeleteTableBtn,
            separateFromAbove: true,
            disabled: !db.deletionAt,
            visible: !!db.deletionAt,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: false,
            visible: activeDataBreach,
            disabled: !!db.deletionAt,
          },
        ];
      }
      case 'notifications': {
        const n: Notification = entityDetailsPayload;
        // const activeModuleDataBreach: boolean = this.permissionManager.currentPermission.includes(PtPermissions.ACTIVE_MODULE_DATABREACH)
        // const canManageDataBreach: boolean = this.permissionManager.currentPermission.includes(PtPermissions.MANAGE_DATABREACH);
        // const activeDataBreach = activeModuleDataBreach && canManageDataBreach;
        return [
          {
            ...this.openDocumentTableBtn,
            visible: true, //activeDataBreach,
            disabled: n.builtIn,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: true, //activeDataBreach,
            disabled: n.builtIn,
          },
        ];
      }
    }
    return [];
  }

  private ofTableDPG(entity: PtEntity, entityDetailsPayload: any): ColAction[] {
    switch (entity) {
      case 'legalEntity': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);
        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }

      case 'organizationalFunctions': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'userResources': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'privacyRole': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);
        const entity: PrivacyRole = entityDetailsPayload;
        return [
          {
            ...this.editTableBtn,
            visible: permissionDPG.dpgPermission,
            disabled: !permissionDPG.system
              ? permissionDPG.requiredBuiltIn
              : false,
          },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
            disabled: entity.builtIn,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'employmentRelationship': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);
        const entity: Employment = entityDetailsPayload;
        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
            disabled: entity.builtIn,
          },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'applications': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'applicationTypes': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'regulations': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'notices': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'purposeCategory': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'recipients': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'suppliers': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);

        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'department': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);
        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
      case 'treatmentCategory': {
        const permissionDPG: DataProtectionGovernancePermission =
          this.permissionManager.dpgPermission(entityDetailsPayload);
        return [
          { ...this.editTableBtn, visible: permissionDPG.dpgPermission },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: permissionDPG.dpgPermission,
          },
        ];
      }
    }
    return [];
  }

  private ofTableBPM(
    entity: PtEntity,
    availableOperations: AvailableOperations
  ): ColAction[] {
    switch (entity) {
      case 'treatmentsHolder':
      case 'treatmentsResponsible':
      case 'treatmentsSubResponsible':
      case 'projectCards':
        const treatmentPermission: DocumentPermission =
          this.permissionManager.treatmentPermission(availableOperations);
        return [
          {
            ...this.openDocumentTableBtn,
            disabled: !treatmentPermission.openBtnEnabled,
            visible: treatmentPermission.openBtnVisible,
          },
          {
            ...this.obsoleteDocumentTableBtn,
            disabled: !treatmentPermission.obsoleteBtnEnabled,
            visible: treatmentPermission.obsoleteBtnVisible,
          },
          {
            ...this.openNewTabDocumentTableBtn,
            disabled: !treatmentPermission.openBtnEnabled,
            visible: treatmentPermission.openBtnVisible,
          },
          {
            ...this.reopenTableBtn,
            disabled: !treatmentPermission.reopenBtnEnabled,
            visible: treatmentPermission.reopenBtnVisible,
          },
          {
            ...this.duplicateTableBtn,
            disabled: !treatmentPermission.duplicateBtnEnabled,
            visible: treatmentPermission.duplicateBtnVisible,
          },
          {
            ...this.duplicateTableBtnForTest,
            disabled: !treatmentPermission.duplicateBtnEnabled,
            visible: false, // Attivare in caso di necessità
          },
          {
            ...this.permissionTableBtn,
            disabled: !treatmentPermission.permissionBtnEnabled,
            visible: treatmentPermission.permissionBtnVisible,
          },
          {
            ...this.downloadPdfTableBtn,
            separateFromAbove: true,
            disabled: !treatmentPermission.downloadBtnEnabled,
            visible: treatmentPermission.downloadBtnVisible,
          },
          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            disabled: !treatmentPermission.detailBtnEnabled,
            visible: treatmentPermission.detailBtnVisible,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            disabled: !treatmentPermission.deleteBtnEnabled,
            visible: treatmentPermission.deleteBtnVisible,
          },
        ];

      case 'appointments':
        const appointmentPermission: AppointmentPermission =
          this.permissionManager.appointmentPermission();
        return [
          {
            ...this.editEntityTableBtn,
            visible: appointmentPermission.editBtnVisible,
            disabled: !appointmentPermission.editBtnEnabled,
          },
          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            visible: appointmentPermission.editBtnVisible,
            disabled: !appointmentPermission.editBtnEnabled,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: appointmentPermission.deleteBtnVisible,
            disabled: !appointmentPermission.deleteBtnEnabled,
          },
        ];

      case 'appAssessment':
        const appAssessmentPermission: DocumentPermission =
          this.permissionManager.appAssessmentPermissionV2(availableOperations);
        return [
          {
            ...this.openDocumentTableBtn,
            disabled: !appAssessmentPermission.openBtnEnabled,
            visible: appAssessmentPermission.openBtnVisible,
          },
          {
            ...this.openNewTabDocumentTableBtn,
            disabled: !appAssessmentPermission.openBtnEnabled,
            visible: appAssessmentPermission.openBtnVisible,
          },
          {
            ...this.reopenTableBtn,
            disabled: !appAssessmentPermission.reopenBtnEnabled,
            visible: appAssessmentPermission.reopenBtnVisible,
          },
          {
            ...this.duplicateTableBtn,
            disabled: !appAssessmentPermission.duplicateBtnEnabled,
            visible: appAssessmentPermission.duplicateBtnVisible,
          },
          {
            ...this.permissionTableBtn,
            disabled: !appAssessmentPermission.permissionBtnEnabled,
            visible: appAssessmentPermission.permissionBtnVisible,
          },
          {
            ...this.downloadPdfTableBtn,
            separateFromAbove: true,
            disabled: !appAssessmentPermission.downloadBtnEnabled,
            visible: appAssessmentPermission.downloadBtnVisible,
          },

          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            disabled: !appAssessmentPermission.detailBtnEnabled,
            visible: appAssessmentPermission.detailBtnVisible,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            disabled: !appAssessmentPermission.deleteBtnEnabled,
            visible: appAssessmentPermission.deleteBtnVisible,
          },
        ];

      case 'globalMeasureCheck':
        const globalMeasureCheckPermission: DocumentPermission =
          this.permissionManager.globalMeasureCheckPermission(
            availableOperations
          );
        return [
          {
            ...this.openDocumentTableBtn,
            disabled: !globalMeasureCheckPermission.openBtnEnabled,
            visible: globalMeasureCheckPermission.openBtnVisible,
          },
          {
            ...this.openNewTabDocumentTableBtn,
            disabled: !globalMeasureCheckPermission.openBtnEnabled,
            visible: globalMeasureCheckPermission.openBtnVisible,
          },
          {
            ...this.reopenTableBtn,
            disabled: !globalMeasureCheckPermission.reopenBtnEnabled,
            visible: globalMeasureCheckPermission.reopenBtnVisible,
          },
          {
            ...this.duplicateTableBtn,
            disabled: !globalMeasureCheckPermission.duplicateBtnEnabled,
            visible: globalMeasureCheckPermission.duplicateBtnVisible,
          },
          {
            ...this.permissionTableBtn,
            disabled: !globalMeasureCheckPermission.permissionBtnEnabled,
            visible: globalMeasureCheckPermission.permissionBtnVisible,
          },
          {
            ...this.downloadPdfTableBtn,
            separateFromAbove: true,
            disabled: !globalMeasureCheckPermission.downloadBtnEnabled,
            visible: globalMeasureCheckPermission.downloadBtnVisible,
          },
          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            disabled: !globalMeasureCheckPermission.detailBtnEnabled,
            visible: globalMeasureCheckPermission.detailBtnVisible,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            disabled: !globalMeasureCheckPermission.deleteBtnEnabled,
            visible: globalMeasureCheckPermission.deleteBtnVisible,
          },
        ];

      case 'aiAssessment':
        const aiPermission: DocumentPermission =
          this.permissionManager.aiAssessmentPermission(availableOperations);
        return [
          {
            ...this.openDocumentTableBtn,
            disabled: !aiPermission.openBtnEnabled,
            visible: aiPermission.openBtnVisible,
          },
          {
            ...this.openNewTabDocumentTableBtn,
            disabled: !aiPermission.openBtnEnabled,
            visible: aiPermission.openBtnVisible,
          },
          {
            ...this.reopenTableBtn,
            disabled: !aiPermission.reopenBtnEnabled,
            visible: aiPermission.reopenBtnVisible,
          },
          {
            ...this.duplicateTableBtn,
            disabled: !aiPermission.duplicateBtnEnabled,
            visible: aiPermission.duplicateBtnVisible,
          },
          {
            ...this.permissionTableBtn,
            disabled: !aiPermission.permissionBtnEnabled,
            visible: aiPermission.permissionBtnVisible,
          },
          {
            ...this.downloadPdfTableBtn,
            separateFromAbove: true,
            disabled: !aiPermission.downloadBtnEnabled,
            visible: aiPermission.downloadBtnVisible,
          },
          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            disabled: !aiPermission.detailBtnEnabled,
            visible: aiPermission.detailBtnVisible,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            disabled: !aiPermission.deleteBtnEnabled,
            visible: aiPermission.deleteBtnVisible,
          },
        ];

      case 'covidAssessment':
        const covidAssessmentPermission: DocumentPermission =
          this.permissionManager.covidAssessmentPermission(availableOperations);
        return [
          {
            ...this.openDocumentTableBtn,
            disabled: !covidAssessmentPermission.openBtnEnabled,
            visible: covidAssessmentPermission.openBtnVisible,
          },
          {
            ...this.openNewTabDocumentTableBtn,
            disabled: !covidAssessmentPermission.openBtnEnabled,
            visible: covidAssessmentPermission.openBtnVisible,
          },
          {
            ...this.publicTableBtn,
            disabled: !covidAssessmentPermission.publishBtnEnabled,
            visible: covidAssessmentPermission.publishBtnVisible,
          },
          {
            ...this.reopenTableBtn,
            disabled: !covidAssessmentPermission.reopenBtnEnabled,
            visible: covidAssessmentPermission.reopenBtnVisible,
          },
          {
            ...this.snapshotTableBtn,
            disabled: !covidAssessmentPermission.snapshotBtnEnabled,
            visible: covidAssessmentPermission.snapshotBtnVisible,
          },
          {
            ...this.duplicateTableBtn,
            disabled: !covidAssessmentPermission.duplicateBtnEnabled,
            visible: covidAssessmentPermission.duplicateBtnVisible,
          },

          {
            ...this.permissionTableBtn,
            disabled: !covidAssessmentPermission.permissionBtnEnabled,
            visible: covidAssessmentPermission.permissionBtnVisible,
          },
          {
            ...this.downloadPdfTableBtn,
            separateFromAbove: true,
            disabled: !covidAssessmentPermission.downloadBtnEnabled,
            visible: covidAssessmentPermission.downloadBtnVisible,
          },
          {
            ...this.showDetailsTableBtn,
            separateFromAbove: true,
            disabled: !covidAssessmentPermission.detailBtnEnabled,
            visible: covidAssessmentPermission.detailBtnVisible,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            disabled: !covidAssessmentPermission.deleteBtnEnabled,
            visible: covidAssessmentPermission.deleteBtnVisible,
          },
        ];
    }
    return [];
  }

  private ofTableAdministration(
    entity: PtEntity,
    entityDetailsPayload: any
  ): ColAction[] {
    switch (entity) {
      case 'organizationalMeasures':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'organizationalMeasureCategories':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'technicalMeasures':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'technicalMeasureCategories':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'preliminaryRiskAssessment':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'interestedPersonCategories':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'natureOfData':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'damage':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'legalBasis':
        return [
          { ...this.editTableBtn, visible: true },

          { ...this.showDetailsTableBtn, separateFromAbove: true },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },

          {
            ...this.editPriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.increasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
          {
            ...this.decreasePriorityTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'userGroups':
        return [
          {
            ...this.editTableBtn,
            visible: true,
          },
          { ...this.showDetailsTableBtn, separateFromAbove: true },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: true,
          },
        ];
      case 'permissionRules':
        return [
          { ...this.editTableBtn, visible: true },
          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },
        ];
      case 'users':
        if (entityDetailsPayload?.loggedUser) {
          const loggedUser = entityDetailsPayload?.loggedUser;
          return [
            {
              ...this.editTableBtn,
              visible: true,
              disabled: !loggedUser?.system
                ? entityDetailsPayload?.builtIn
                : false,
            },
            { ...this.showDetailsTableBtn, separateFromAbove: true },
            {
              ...this.unlockUserAccessTableBtn,
              separateFromAbove: true,
              visible: true,
            },
            {
              ...this.deleteTableBtn,
              separateFromAbove: true,
              visible: true,
              disabled: !loggedUser?.system
                ? entityDetailsPayload?.builtIn
                : false,
            },
          ];
        } else {
          return [
            {
              ...this.editTableBtn,
              visible: true,
              disabled: entityDetailsPayload?.builtIn,
            },
            { ...this.showDetailsTableBtn, separateFromAbove: true },
            {
              ...this.unlockUserAccessTableBtn,
              separateFromAbove: true,
              visible: true,
            },
            {
              ...this.deleteTableBtn,
              separateFromAbove: true,
              visible: true,
              disabled: entityDetailsPayload?.builtIn,
            },
          ];
        }
    }
    return [];
  }

  private ofTableConsoleUI(
    entity: PtEntity,
    entityDetailsPayload: any
  ): ColAction[] {
    switch (entity) {
      case 'consoleOrganizations':
        return [
          { ...this.editTableBtn, visible: true },

          {
            ...this.visitCustomerDomainTableBtn,
            separateFromAbove: true,
            visible: true,
          },

          {
            ...this.enableTableBtn,
            separateFromAbove: true,
            visible: true,
            disabled: entityDetailsPayload.enabled,
          },
          {
            ...this.disableTableBtn,
            separateFromAbove: true,
            visible: true,
            disabled: !entityDetailsPayload.enabled,
          },

          { ...this.deleteTableBtn, separateFromAbove: true, visible: true },
        ];
      case 'consoleUsers': {
        const entity: User = entityDetailsPayload;
        return [
          {
            ...this.editEntityTableBtn,
            visible: true,
            disabled: entity.builtIn,
          },
          {
            ...this.deleteTableBtn,
            separateFromAbove: true,
            visible: true,
            disabled: entity.builtIn,
          },
        ];
      }
    }
    return [];
  }
}
